import { uuid } from '../utils';
import {
  ILLUSTRATION
} from './categories';

export default {
  id: uuid(),
  priority: 1,
  name: 'Crayons',
  thumbnail: './Crayons/01_Crayons-Thumb.jpg',
  categories: [ ILLUSTRATION ],
  content: [
    'Crayons/Auntie.jpg',
    'Crayons/Backride copy.jpg',
    'Crayons/Bath copy.jpg',
    'Crayons/Batman.jpg',
    'Crayons/Boys.jpg',
    'Crayons/Dad-read_orange.jpg',
    'Crayons/Ent_Peacock.jpg',
    'Crayons/Ent_Peacock_det.jpg',
    'Crayons/Fishees.jpg',
    'Crayons/Giant-crash.jpg',
    'Crayons/Giant-croc.jpg',
    'Crayons/Giant_sleep_HDR.jpg',
    'Crayons/Giant_sleep_HDR_det01.jpg',
    'Crayons/Kaidan.jpg',
    'Crayons/reading.jpg',
    'Crayons/reading_det.jpg',
    'Crayons/Red_Cat.jpg',
    'Crayons/Red_Cat_Det2.jpg',
    'Crayons/Street.jpg',
    'Crayons/Tanzen2.jpg',
    'Crayons/twoCircus.jpg',
    'Crayons/twoCircus_det2.jpg'
  ]
};




// WEBPACK FOOTER //
// ./src/projects/crayons.js